import { createFileRoute } from '@tanstack/react-router'
import { ServiceDashboardPage } from '../../../features/service/dashboard-page'

export const Route = createFileRoute('/_app/service/')({
  staticData: { crumb: 'service' },
  component: ServiceDashboardPage,
})
